import { render, staticRenderFns } from "./SeguiRotacion.vue?vue&type=template&id=6e2b8920&scoped=true&"
import script from "./SeguiRotacion.vue?vue&type=script&lang=js&"
export * from "./SeguiRotacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b8920",
  null
  
)

export default component.exports